import Rest from '../Services/Rest'

/**
 * @typedef {LoginService}
 */
export default class LoginService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/auth'

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  login (record) {    
    return this.post('/login', record)
  }

  logout () {    
    return this.post('/logout')
  }

}